export const HYBRID_SEARCH_MODE_COOKIE_NAME = 'hybridSearchMode';
